module.exports = __webpack_public_path__ + "img/icn-help.993cd056.svg";